import {roles} from "../../../../index";


const {super_admin, provider} = roles;

export const EMY_PRODUCT_STATUSES = {
  UNDER_REVIEW: {
    key: 'UNDER_REVIEW',
    className: 'info',
    roles: [super_admin]
  },
  APPROVED: {
    key: 'APPROVED',
    className: 'primary',
    roles: [super_admin]
  },
  REJECTED: {
    key: 'REJECTED',
    className: 'danger',
    roles: [super_admin]
  },
  ARCHIVED: {
    key: 'ARCHIVED',
    className: 'dark',
    roles: [super_admin, provider]
  },
}
export const getStatuses = () => {
  return Object.values(EMY_PRODUCT_STATUSES)
}
export const getStatusesKeys = (role) => {
  return getStatuses(role).map(v => v.key)
}

export const isApproved = entity => entity.status !== EMY_PRODUCT_STATUSES.APPROVED.key

